@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";

.features-container {
  display: flex;
  flex-direction: column;
  background-color: colors.$input-background-color;
  border-radius: 0.667em;

  p {
    font-size: 1.11111111em;
    line-height: 160%;
  }

  h1 {
    border-bottom: 0;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .add-feature-container {
    padding: 2em;

    p.note {
      font-size: 0.888888888em; // maps to 16px
      color: colors.$secondary-text-color;
      margin-bottom: 0;
    }
  }
}

.features-cta {
  font-size: 1.111111111em; // maps to 20px
  font-weight: 700;

  line-height: 1.1em; // maps to 22px
  margin-bottom: 0.5em;
}

.add-feature {
  display: flex;

  & > div {
    display: flex;
    flex-grow: 1;

    // ugh
    & > div {
      display: flex;
      flex-direction: column;
      flex-grow: inherit;

      input {
        border: none;
      }
    }
  }

  .add-button {
    margin-left: 1em;
  }
}

.created-features {
  margin: 0.25em;
  padding: 1em 2em;
  background-color: colors.$primary-background-color;
  border-radius: 0 0 0.667em 0.667em;
}

.config-item-container {
  display: flex;
  flex-direction: column;

  &.visible {
    margin-top: 2em;

    &:first-of-type {
      margin-top: 0;
    }
  }

  &.hidden {
    display: none;
  }

  &.visible-after-hidden {
    margin-top: 0;
  }
}

.feature {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:not(:first-of-type) {
    margin-top: 2em;
  }

  .feature-title-group {
    display: flex;
    align-items: center;

    .validation-status {
      display: flex;
      height: 1.3em;
      min-width: 1.3em;
      background-color: colors.$primary-brand-color;
      border-radius: 3em;
      align-items: center;
      justify-content: center;

      svg {
        height: 16px;
      }

      &.dirty {
        background-color: colors.$error-color;
        color: colors.$primary-background-color;
        font-weight: 700;
      }
    }

    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 2em;

      .feature-index {
        font-size: 0.9em;
        color: colors.$secondary-text-color;
      }

      .feature-title {
        font-size: 1.22em;
        line-height: 1.8em;
        font-weight: 650;
        word-break: break-word;
      }
    }
  }

  .feature-button-group {
    display: flex;
  }

  a.remove-config {
    text-decoration: underline;
    align-self: center;

    margin-left: 2em;

    font-size: 0.888888888em;

    color: colors.$secondary-text-color;

    cursor: pointer;
  }
}

.big-modal-container {
  width: 100%;
  height: 100%;
  text-align: left;

  .feature-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    .header-flex-item {
      display: flex;

      width: 10em;

      // close button
      &:first-child {
        button {
          margin-left: 0;
        }
      }

      // modal title
      &:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    p {
      font-size: 1.25em;
      font-weight: 700;
      color: colors.$secondary-text-color;
      text-align: center;
    }

    .feature-questions {
      display: flex;
      height: 2.666666666666em; // maps to 48px
      width: 2.666666666666em;
      background-color: colors.$primary-text-color;
      color: colors.$primary-background-color;
      border-radius: 3em;
      align-items: center;
      justify-content: center;
    }
  }

  .form-content {
    padding: 4em;

    .label {
      font-size: 1.11111111em;
    }

    .required-config {
      margin-top: 1em;
    }
  }

  .non-step-fields {
    width: 60%;

    div[class^="fieldset composer-fieldset"] {
      background-color: colors.$primary-background-color;
      border: 4px solid #f5f5f5;
      margin-top: 2em;
    }

    .icon-row {
      display: flex;
      flex-direction: row;
      margin-top: 2em;

      .icon {
        display: flex;
        align-items: center;
        margin: 0 20px;
      }

      .select {
        display: flex;
        flex-basis: 50%;
      }
    }
  }

  .align-left {
    text-align: left;
  }

  .step-config-section {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    margin: 3em 0 0 0;

    .left-button {
      display: flex;

      button {
        margin: 0;
      }
    }

    div[class^="partners-tanda-composer-selectors"] {
      margin-bottom: 1em;
    }
  }

  .right-button {
    display: flex;
    justify-content: flex-end;

    button {
      display: flex;
      margin: 0;
    }
  }

  .horizontal-rule {
    display: flex;
    align-self: center;

    width: 100%;
    height: 0.0666666666em;

    margin-left: 2em;

    border-bottom: 0.22222222em solid #f6f6f6; // maps to 4px

    &.space {
      margin: 5em 0;
    }
  }

  textarea {
    position: relative;
  }
}
